export { default } from './SocialIcon';
